<template>
  <div id="container">
    <div v-show="mostrarLegenda" style="overflow:scroll; max-height: 90px;">
      <div :id="legenddiv" style="width: 100%; height: 100%; min-height: 83px; max-height: 200px; min-width: 200px;"></div>
    </div>
    <div class="chartwrapper" v-bind:style="{ maxHeight: maxHeightBar }">
      <div :id="bar" v-bind:style="{ minHeight: maxHeightBar, maxHeight: maxHeightBar, width: width, height: height, minWidth: minWidth }"></div>
    </div>
  </div>
</template>

<script>
import loadChart from '../../../../../produto/shared-components/chart/loadChart';

export default {
  name: 'GraficoBarrasSegmentacao',
  props: {
    categoryField: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    sortColumns: {
      type: Boolean,
      default: false,
    },
    colors: {
      type: Array,
    },
    valueFields: {
      type: Array,
      required: true,
    },
    dados: {
      type: Array,
      required: true,
    },
    unitYAxis: {
      type: String,
      default: '',
    },
    infoYAxis: {
      type: String,
      default: '',
    },
    qtdColunasLegenda: {
      type: Number,
      default: 10,
    },
    tipoBarraRanking: {
      type: Boolean,
      default: false,
    },
    precision: {
      type: Number,
      default: 2,
    },

  },
  watch: {
    dados() {
      this.montarGrafico();
    },
  },
  data() {
    return {
      isReady: false,
      barchart3dconf: {
        theme: 'light',
        type: 'serial',
        sortColumns: false,
        gridAboveGraphs: false,
        startDuration: 1,
        graphs: [],
        plotAreaFillAlphas: 0.1,
        depth3D: 12,
        angle: 55,
        autoResize: true,
        rotate: false,
        categoryAxis: {
          gridPosition: 'start', gridAlpha: 0, tickPosition: 'start', tickLength: 20, labelRotation: 0,
        },
        legend: {
          enabled: !this.tipoBarraRanking,
          maxColumns: this.qtdColunasLegenda || 10,
          align: 'center',
          useGraphSettings: true,
          position: 'top',
        },
        export: {
          enabled: false,
        },
        valueAxes: [],
      },
      bar: 'bar',
      legenddiv: 'legend',
      chartTitle: '',
      maxHeightBar: !this.tipoBarraRanking ? '200px' : '290px',
      width: '100%',
      height: '100%',
      minWidth: '200px',
      mostrarLegenda: !this.tipoBarraRanking,
    };
  },
  methods: {
    montarGrafico() {
      if (typeof AmCharts === 'undefined') return;
      this.barchart3dconf.categoryField = this.categoryField;
      this.barchart3dconf.export.fileName = this.title !== '' ? this.title : this.chartTitle;
      this.barchart3dconf.sortColumns = this.sortColumns;
      this.barchart3dconf.columnSpacing = 12;
      this.barchart3dconf.tipoBarraRanking = this.tipoBarraRanking;
      this.barchart3dconf.valueAxes.push({
        gridColor: '#90A4AE',
        unit: this.unitYAxis,
        gridAlpha: 0.5,
        axisAlpha: 0,
        dashLength: 1,
        unitPosition: 'left',
        position: 'left',
        title: this.infoYAxis,
      });
      this.barchart3dconf.graphs = [];
      this.valueFields.forEach((el) => {
        if (!this.tipoBarraRanking) {
          this.barchart3dconf.graphs.push(this.getGraficoBarra(el));
        } else {
          this.barchart3dconf.graphs.push(this.getGraficoBarraRanking(el));
        }
      });

      if (!this.tipoBarraRanking) {
        this.barchart3dconf.numberFormatter = {
          precision: 2,
          decimalSeparator: ',',
          thousandsSeparator: '.',
        };
      }

      this.barchart3dconf.dataProvider = this.dados || [];
      AmCharts.addInitHandler((chart) => {
        chart.addListener('drawn', (e) => {
          if (e.chart.resizedTO) {
            delete e.chart.resizedTO;
          }
        });

        if ((!chart || !chart.graphs) || (!chart.dataProvider || chart.dataProvider.length < 1)) {
          return;
        }

        chart.categoryAxis.labelRotation = chart.dataProvider.length > 5 ? 45 : 0;
        if (chart.tipoBarraRanking === false) {
          return;
        }

        chart.graphs.forEach((value, index) => {
          const graph = chart.graphs[index];
          const colorKey = `autoColor-${index}`;
          graph.lineColorField = colorKey;
          graph.fillColorsField = colorKey;

          chart.dataProvider.forEach((valor, i) => {
            const color = chart.colors[i];
            chart.dataProvider[i][colorKey] = color;
          });
        });
      }, ['serial']);
      this.barchart3dconf.legend.divId = this.legenddiv;
      AmCharts.makeChart(this.bar, this.barchart3dconf);
    },
    getGraficoBarra(el) {
      return {
        balloonText: `${el.balloonText}`,
        fillAlphas: 0.8,
        lineAlpha: 0.2,
        title: `${el.title}`,
        type: 'column',
        valueField: el.valueField,
        precision: this.precision,
        decimalSeparator: ',',
        thousandsSeparator: '.',
      };
    },
    getGraficoBarraRanking(el) {
      return {
        balloonText: `${el.balloonText}`,
        labelText: '[[value]]',
        labelPosition: 'top',
        fontSize: 14,
        padding: '10px',
        fillAlphas: 0.8,
        lineAlpha: 0.2,
        title: `${el.title}`,
        type: 'column',
        valueField: el.valueField,
      };
    },
  },
  mounted() {
    window.addEventListener('AmChart3Carregado', () => {
      this.isReady = true;
    });
  },
  beforeMount() {
    loadChart().then(() => {
      window.dispatchEvent(new Event('AmChart3Carregado'));
      this.montarGrafico();
    });
  },
};
</script>

<style>
  #legend svg{
    position: unset !important;
  }
</style>
